import React, {useEffect, useState} from "react";
import DataTable from "../../DataTable/index";
import IconButton from "@mui/material/IconButton";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import {Alert, Box, CircularProgress, Typography,} from "@mui/material";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import ApiEndpoints from "../../../utils/ApiEndpoints";
import {apiGet} from "../../../utils/apiRequests";

export default function MyComponent(props) {
    const navigate = useNavigate();
    const userRole = useSelector((state) => state.userDetailsReducer?.role);

    const [playersList, setPlayersList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("Error: ");
    const [tableHeight, setTableHeight] = useState("70vh");

    const columns = [
        {
            name: (
                <Typography variant="subtitle2" sx={{fontWeight: 700}}>
                    Name
                </Typography>
            ),
            selector: (row) => (
                <p data-tag="allowRowEvents">
                    {row.first_name} {row.last_name}
                </p>
            ),
            sortable: true,
        },
        {
            name: (
                <Typography
                    variant="subtitle2"
                    sx={{
                        width: "100%",
                        textAlign: "center",
                        fontWeight: 700,
                        paddingLeft: "15px",
                    }}
                >
                    WHS H.I.
                </Typography>
            ),
            selector: (row) => row.handicap,
            sortable: true,
            cell: (row) => {
                return (
                    <p
                        data-tag="allowRowEvents"
                        style={{marginTop: 15, width: "100%", textAlign: "center"}}
                    >
                        {row.handicap}
                    </p>
                );
            },
        },
        {
            name: (
                <Typography
                    variant="subtitle2"
                    sx={{width: "100%", textAlign: "center", fontWeight: 700}}
                >
                    Blue TEE. H.C
                </Typography>
            ),
            selector: (row) => row.tees[0]?.handicap_value,
            sortable: true,
            cell: (row) => {
                let filterBlue = row?.tees.filter((val) => val?.tee_color === "blue");
                return (
                    <>
                        {filterBlue.length > 0 && filterBlue[0].is_default ? (
                            <div
                                style={{
                                    border: "1px solid #ccc",
                                    borderRadius: "50%",
                                    padding: "10px",
                                    width: "40px",
                                    height: "40px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    margin: "0px auto",
                                }}
                            >
                                <p
                                    data-tag="allowRowEvents"
                                    style={{marginTop: 15, width: "100%", textAlign: "center"}}
                                >
                                    {row.tees[0]?.handicap_value}
                                </p>
                            </div>
                        ) : (
                            <p
                                data-tag="allowRowEvents"
                                style={{marginTop: 15, width: "100%", textAlign: "center"}}
                            >
                                {row.tees[0]?.handicap_value}
                            </p>
                        )}
                    </>
                );
            },
        },
        {
            name: (
                <Typography
                    variant="subtitle2"
                    sx={{width: "100%", textAlign: "center", fontWeight: 700}}
                >
                    White TEE. H.C
                </Typography>
            ),
            selector: (row) => row.tees[1]?.handicap_value,
            sortable: true,
            cell: (row) => {
                let filterWhite = row?.tees.filter((val) => val?.tee_color === "white");
                return (
                    <>
                        {filterWhite.length > 0 && filterWhite[0].is_default ? (
                            <div
                                style={{
                                    border: "1px solid #ccc",
                                    borderRadius: "50%",
                                    padding: "10px",
                                    width: "40px",
                                    height: "40px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    margin: "0px auto",
                                }}
                            >
                                <p
                                    data-tag="allowRowEvents"
                                    style={{marginTop: 15, width: "100%", textAlign: "center"}}
                                >
                                    {row.tees[1]?.handicap_value}
                                </p>
                            </div>
                        ) : (
                            <p
                                data-tag="allowRowEvents"
                                style={{marginTop: 15, width: "100%", textAlign: "center"}}
                            >
                                {row.tees[1]?.handicap_value}
                            </p>
                        )}
                    </>
                );
            },
        },
        {
            name: (
                <Typography
                    variant="subtitle2"
                    sx={{width: "100%", textAlign: "center", fontWeight: 700}}
                >
                    Yellow TEE. H.C
                </Typography>
            ),
            selector: (row) => row.tees[2]?.handicap_value,
            sortable: true,
            cell: (row) => {
                let filterYellow = row?.tees.filter(
                    (val) => val?.tee_color === "yellow"
                );
                return (
                    <>
                        {filterYellow.length > 0 && filterYellow[0].is_default ? (
                            <div
                                style={{
                                    border: "1px solid #ccc",
                                    borderRadius: "50%",
                                    padding: "10px",
                                    width: "40px",
                                    height: "40px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    margin: "0px auto",
                                }}
                            >
                                <p
                                    data-tag="allowRowEvents"
                                    style={{marginTop: 15, width: "100%", textAlign: "center"}}
                                >
                                    {filterYellow[0]?.handicap_value || row.tees[2]?.handicap_value}
                                </p>
                            </div>
                        ) : (
                            <p
                                data-tag="allowRowEvents"
                                style={{marginTop: 15, width: "100%", textAlign: "center"}}
                            >
                                {filterYellow[0]?.handicap_value || row.tees[2]?.handicap_value}
                            </p>
                        )}
                    </>
                );
            },
        },
        {
            name: (
                <Typography
                    variant="subtitle2"
                    sx={{width: "100%", textAlign: "center", fontWeight: 700}}
                >
                    Black TEE. H.C
                </Typography>
            ),
            selector: (row) => {
                let filterBlack = row?.tees?.filter((val) => val?.tee_color === "black");
                return filterBlack && filterBlack.length > 0 ? filterBlack[0]?.handicap_value : row.tees[3]?.handicap_value;
            },
            sortable: true,
            cell: (row) => {
                let filterBlack = row?.tees?.filter((val) => val?.tee_color === "black");
                let val = filterBlack && filterBlack.length > 0 ? filterBlack[0]?.handicap_value : row.tees[3]?.handicap_value;
                let isDefault = filterBlack && filterBlack.length > 0 ? filterBlack[0].is_default : false;
                return (
                    <>
                        {isDefault ? (
                            <div
                                style={{
                                    border: "1px solid #ccc",
                                    borderRadius: "50%",
                                    padding: "10px",
                                    width: "40px",
                                    height: "40px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    margin: "0px auto",
                                }}
                            >
                                <p
                                    data-tag="allowRowEvents"
                                    style={{marginTop: 15, width: "100%", textAlign: "center"}}
                                >
                                    {val}
                                </p>
                            </div>
                        ) : (
                            <p
                                data-tag="allowRowEvents"
                                style={{marginTop: 15, width: "100%", textAlign: "center"}}
                            >
                                {val}
                            </p>
                        )}
                    </>
                );
            },
        },
        {
            name: (
                <Typography variant="subtitle2" fontWeight={700}>
                    Actions
                </Typography>
            ),
            sortable: true,
            cell: (row) => {
                return (
                    <>
                        <IconButton
                            style={{borderRadius: 5}}
                            onClick={() => props.onDeletePress(row)}
                            color="primary"
                            size="medium"
                        >
                            <DeleteRoundedIcon fontSize="medium"/>
                        </IconButton>
                    </>
                );
            },
        },
        // {
        //   name: (
        //     <Typography
        //       variant="subtitle2"
        //       sx={{ width: "100%", textAlign: "center", fontWeight: 700 }}
        //     >
        //       Action
        //     </Typography>
        //   ),
        //   // selector: (row) => row.tees[2]?.handicap_value,
        //   sortable: true,
        //   cell: (row) => {
        //     return (
        //       <div
        //         style={{
        //           width: "100%",
        //           textAlign: "center",
        //         }}
        //       >
        //         <Button
        //           variant="contained"
        //           color="error"
        //           onClick={() => alert("Coming Soon")}
        //         >
        //           Delete
        //         </Button>
        //       </div>
        //     );
        //   },
        // },
    ];

    const getDimension = () => {
        if (window.innerWidth > 776) {
            setTableHeight("70vh");
        } else if (window.innerWidth < 776 && window.innerWidth > 600) {
            setTableHeight("60vh");
        } else if (window.innerWidth < 600 && window.innerWidth > 300) {
            setTableHeight("35vh");
        } else if (window.innerWidth < 300) {
            setTableHeight("30vh");
        }
    };

    window.addEventListener("resize", getDimension);

    useEffect(() => {
        getDimension();
    }, []);

    const customStyles = {
        table: {
            style: {
                height: tableHeight,
                overflowY: "scroll",
            },
        },
        rows: {
            style: {
                "&:hover": {
                    cursor: "pointer",
                },
            },
        },
        headRow: {
            style: {
                border: "1px solid #C4C4C4 !important",
                borderRadius: "5px",
                position: "sticky",
                top: 0,
            },
        },
        head: {
            style: {
                position: "sticky",
                top: "0",
                background: "white",
                zIndex: 99,
            },
        },
    };

    const RenderNoData = () => {
        return (
            <Box>
                <Typography mt={1}>Loading...</Typography>
            </Box>
        );
    };

    const getPlayerList = () => {
        if (userRole === "player") {
            apiGet(
                ApiEndpoints.allPlayers.player,
                (res) => {
                    setIsLoading(false);
                    setPlayersList(res?.players);
                    props.setValue(res?.players);
                },
                (err) => {
                    setIsError(true);
                    setIsLoading(false);
                    setErrorMessage(err?.message);
                }
            );
        } else if (userRole === "admin" || userRole === "super") {
            apiGet(
                ApiEndpoints.allPlayers.base,
                (res) => {
                    setIsLoading(false);
                    setPlayersList(res?.players);
                    props.setValue(res?.players);
                },
                (err) => {
                    setIsError(true);
                    setIsLoading(false);
                    setErrorMessage(err?.message);
                }
            );
        }
    };

    useEffect(() => {
        getPlayerList();
    }, [userRole]);

    return isLoading ? (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
            }}
        >
            <CircularProgress color="success"/>
            <Typography mt={1}>Loading...</Typography>
        </Box>
    ) : isError ? (
        <Alert severity="error" sx={{marginTop: 2}}>
            {errorMessage}
        </Alert>
    ) : (
        <DataTable
            columns={columns}
            data={props.value === "" ? playersList : props.searchData}
            noDataComponent={RenderNoData}
            persistTableHead
            pagination={false}
            customStyles={customStyles}
            direction="vertical"
            striped={true}
            onRowClicked={(row) => {
                navigate(`/player-profile/${row._id}`, {
                    replace: false,
                    state: {row},
                });
            }}
        />
    );
}
